import designBaseBreakpoints from '../breakpoints';

export const breakpoints = {
  values: designBaseBreakpoints,
};
